module.exports = __webpack_public_path__ + "img/spasm.64a06495.webp";